import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { BookActivity } from "@modules/bookActivities/types";

export function useBookActivities() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createBookActivityModalRef = useRef<ModalRef>(null);
  const editBookActivityModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<BookActivity>({
    resource: "v1/book_activity_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createBookActivityModalRef,
    editBookActivityModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
